module.exports = __webpack_public_path__ + "img/bg.a7ed7340.png";